export enum EventType {
  AG = 'AG',
  CABT = 'CABT',
  FCAT = 'FCAT',
  RLY = 'RLY',
  SCWK = 'SCWK',
}

export enum EventStatus {
  OPEN = 'Open',
  COMING = 'Coming',
}

export enum EventEntryMethod {
  FIRST = 'FirstReceived',
  RANDOM = 'Random',
}

export const EventTypes = {
  [EventType.AG]: {
    name: 'Agility',
    color: 'red',
  },
  [EventType.CABT]: {
    name: 'Coursing Ability Test',
    color: 'yellow',
  },
  [EventType.FCAT]: {
    name: 'FastCAT',
    color: 'green',
  },
  [EventType.RLY]: {
    name: 'Rally',
    color: 'blue',
  },
  [EventType.SCWK]: {
    name: 'Scentwork',
    color: 'purple',
  },
};

export const EventStatuses = {
  [EventStatus.OPEN]: 'Registration open',
  [EventStatus.COMING]: 'Registration coming soon',
};

export const EventEntryMethods = {
  [EventEntryMethod.FIRST]: 'First received',
  [EventEntryMethod.RANDOM]: 'Random draw',
};
